export default function EngineeringOverviewSection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Left: Abstract visual block */}
          <div className="lg:w-[50%]">
            <div className="w-full aspect-[7/5] rounded-[32px] overflow-hidden relative"
              style={{
                background: 'linear-gradient(160deg, oklch(0.18 0.01 260) 0%, oklch(0.12 0.005 240) 30%, oklch(0.08 0.003 220) 60%, oklch(0.05 0.002 200) 100%)',
              }}
            >
              <div className="absolute inset-0 opacity-30"
                style={{
                  background: 'radial-gradient(ellipse 80% 60% at 30% 40%, oklch(0.28 0.02 250) 0%, transparent 70%), radial-gradient(ellipse 50% 50% at 70% 60%, oklch(0.22 0.015 230) 0%, transparent 70%)',
                }}
              />
              <div className="absolute inset-0 opacity-20"
                style={{
                  backgroundImage: 'linear-gradient(45deg, oklch(0.3 0.01 240) 1px, transparent 1px), linear-gradient(-45deg, oklch(0.25 0.01 240) 1px, transparent 1px)',
                  backgroundSize: '60px 60px',
                }}
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-[50%] flex flex-col justify-between">
            <div>
              <h2 className="font-heading text-[2.2rem] md:text-[2.8rem] lg:text-[3.2rem] leading-[1.05] tracking-[-0.015em] text-foreground-950">
                Modern Digital
                <br />
                Solutions
              </h2>

              <div className="flex items-center gap-4 mt-6 flex-wrap">
                <span className="text-[11px] uppercase tracking-[0.1em] font-medium text-foreground-600 border border-foreground-300/40 rounded-full px-4 py-1.5 font-label whitespace-nowrap">
                  iOS Platform
                </span>
                <span className="text-[11px] uppercase tracking-[0.1em] font-medium text-foreground-500 font-label whitespace-nowrap">
                  Clean Architecture
                </span>
                <span className="text-[11px] uppercase tracking-[0.1em] font-medium text-foreground-500 font-label whitespace-nowrap">
                  Performance
                </span>
              </div>
            </div>

            <div className="mt-10 lg:mt-0 bg-primary-800 rounded-[28px] p-8 md:p-10 flex flex-col md:flex-row gap-8">
              <div className="md:w-[60%]">
                <span className="text-[11px] uppercase tracking-[0.12em] text-foreground-400/70 font-label">
                  Approach
                </span>
                <h3 className="font-heading text-xl md:text-2xl text-background-50 mt-3 leading-tight">
                  Scalable by Design
                </h3>
                <p className="text-sm text-foreground-300/80 mt-3 leading-relaxed">
                  Every system is built with scalability and maintainability as first principles.
                  User-centered design and modern engineering practices ensure solutions
                  remain robust and adaptable as requirements evolve.
                </p>
              </div>
              <div className="md:w-[40%] flex items-center justify-center">
                <div className="w-32 h-32 rounded-full opacity-20"
                  style={{
                    background: 'radial-gradient(circle at center, oklch(0.55 0.02 230) 0%, oklch(0.3 0.01 230) 40%, transparent 70%)',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}